module.exports = __webpack_public_path__ + "img/PW.dfe3da16.png";